const EPK = () => {
  return (
    <div>
      <h1>EPK</h1>
    </div>
  );
};

export default EPK;
